export const EDITOR_SEND_MESSAGE_COMMAND = 'send-message-commnad';

export const MAIN_CLASS_NAME = 'message-input';
export const HEADER_CLASS_NAME = `${MAIN_CLASS_NAME}__header`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const CONTROLS_CLASS_NAME = `${MAIN_CLASS_NAME}__controls`;
export const CONTROLS_MAIN_CLASS_NAME = `${CONTROLS_CLASS_NAME}__main`;
export const CONTROLS_EXTRA_CLASS_NAME = `${CONTROLS_CLASS_NAME}__extra`;
